import { DatePipe } from '@angular/common';
import type { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { omit } from 'lodash';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ApiServiceService } from '../api-service.service';
import { CommonDropdownSearchComponent } from '../common-component-dropdown-search/common-component-dropdown-search.component';
import { CommonInfoTooltipComponent } from '../common-component-info-tooltip/common-component-info-tooltip.component';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { CommonSearchComponent } from '../common-component-search/common-component-search.component';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';
import { SystemActivityLogInfoComponent } from '../system-activity-log-info/system-activity-log-info.component';
import {
  deviceDetailsKpiInfo,
  deviceDetailsListInfo,
} from './device-details-page.info';

@Component({
  selector: 'app-device-details-page',
  templateUrl: './device-details-page.component.html',
  styleUrls: ['./device-details-page.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    DatePipe,
    MatTooltip,
    MatIcon,
    NgxPaginationModule,
    CommonSearchComponent,
    CommonPaginationComponent,
    CommonDropdownSearchComponent,
    CommonInfoTooltipComponent,
    SystemActivityLogInfoComponent,
  ],
})
export class DeviceDetailsPageComponent implements OnInit {
  projectName = environment.projectName;

  // Plain-language explanations shown by the info-tooltip icons on each KPI
  // card, kept in their own file (imported above) for isolation from this
  // component's logic.
  kpiInfo = deviceDetailsKpiInfo;

  // Explanations for the Login Packets/Health Packets/Device System
  // Activity Log lists further down the page.
  listInfo = deviceDetailsListInfo;

  size = 10;
  totalCount = 0;
  page = 1;

  size2 = 10;
  totalCount2 = 0;
  page2 = 1;
  deviceHealth = [];
  deviceLogin = [];

  simDataDetails: {
    primaryOperator?: string;
    primaryMobileNumber?: string;
    secondaryOperator?: string;
    secondaryMobileNumber?: string;
    simStatus?: string;
    activationStatus?: string;
    activationStartDate?: string;
    activationExpiryDate?: string;
    vahanStatus?: string;
  } = {};
  deviceDetails: {
    uid?: string;
    imei?: string;
    iccid?: string;
    state?: { state: string };
    currentPort?: string;
    lastOnline?: string;
    ufw?: string;
  } = {};
  selectedLoginPacket: {
    REQID_LOGIN_MSG_TATA?: string;
    RTCL_VERSION_TATA?: string;
    Time?: string;
    IMEI?: string;
    ICCID?: string;
    chesisNo?: string;
    firmwareSource?: string;
    primaryIp?: string;
    secondaryIp?: string;
    secondaryPort?: string;
    noOfFuelTank?: string;
    primaryTankCap?: string;
    primaryTankWidth?: string;
    primaryTankHeight?: string;
    primaryTankDiameter?: string;
    primaryTankType?: string;
    primaryTankAFTType?: string;
    secondaryTankCap?: string;
    secondaryTankLen?: string;
    secondaryTankWidth?: string;
    secondaryTankHeight?: string;
    secondaryTankDiameter?: string;
    secondaryTankType?: string;
    latitude?: string;
    latitudeDir?: string;
    longitude?: string;
    longitudeDir?: string;
    mainInputVtg?: string;
    intBatteryVtg?: string;
    ignition?: string;
    tamper?: string;
    emergency?: string;
    calibValidFlag?: string;
    gpsDataFlag?: string;
  } = {};
  selectedHealthPacket: {
    packetType?: string;
    Reserved?: string;
    UIN?: string;
    fwVer?: string;
    upTime?: string;
    CALIB?: string;
    angleStatic?: string;
    rawAxisStaticX_AXIS?: string;
    rawAxisStaticY_AXIS?: string;
    rawAxisStaticZ_AXIS?: string;
    angleMotion?: string;
    rawAxisMotionX_AXIS?: string;
    rawAxisMotionY_AXIS?: string;
    rawAxisMotionZ_AXIS?: string;
    usedHeap?: string;
    totalHeap?: string;
    histCount?: string;
    epoch?: string;
    IGN?: string;
    wirecut?: string;
    emergency?: string;
    ntBatt?: string;
    extBatt?: string;
    analogV1?: string;
    analogV2?: string;
    boxTamperRaw?: string;
    gPSDate?: string;
    gPSTime?: string;
    gPSFixQUA?: string;
    lat?: string;
    latDir?: string;
    long?: string;
    longDir?: string;
    numSat?: string;
    speed?: string;
    lastSynced?: string;
    nwState?: string;
    CSQ?: string;
    CREG?: string;
    CGREG?: string;
    SOCKETSTATE?: string;
    mqtt?: string;
    oprName?: string;
    switchRetryCount?: string;
    rebootCounter?: string;
    canBusStatus?: string;
    gpsFwVersion?: string;
    gsmFwVersion?: string;
    footer?: string;
  } = {};

  size3 = 10;
  page3 = 1;
  filter = '';
  totalLength = 0;
  filterList = [
    { key: 'All', value: '' },
    { key: 'FUT_RTC', value: 'FUT_RTC' },
    { key: 'PST_RTC', value: 'PST_RTC' },
    { key: 'SACK', value: 'SACK' },
    { key: 'PrimaryIp', value: 'PrimaryIp' },
    { key: 'SecondaryIp', value: 'SecondaryIp' },
    { key: 'VIN', value: 'VIN' },
    { key: 'UIN', value: 'UIN' },
    { key: 'WIRE_CUT_CRST', value: 'WIRE_CUT_CRST' },
    { key: 'DNF', value: 'DNF' },
    { key: 'MAIN_VTG', value: 'MAIN_VTG' },
    { key: 'INT_BAT_VTG', value: 'INT_BAT_VTG' },
    { key: 'LAT_LONG', value: 'LAT_LONG' },
    { key: 'UNKNOWN', value: 'UNKNOWN' },
  ];
  Responses = [];

  uid = '';
  imei = '';

  deviceForm: FormGroup = this.formBuilder.group({});

  userPermission = [];

  Device_Details_View = false;
  FOTA_Batch_View = false;
  OTA_Batch_View = false;

  private spinnerCount = 0;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public apiMicroservice: ApiServiceService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    if (this.Device_Details_View) {
      this.setDeviceDetailsForm();
      this.deviceDashboard();
      this.getDeviceSystemActivityLog();
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (element.pageName === 'Manual FOTA' && element.view === true) {
          this.FOTA_Batch_View = true;
        }
        if (element.pageName === 'Manual OTA' && element.view === true) {
          this.OTA_Batch_View = true;
        }
        if (element.pageName === 'Device Details' && element.view === true) {
          this.Device_Details_View = true;
        }
        if (element.pageName === 'Device Details' && element.view === false) {
          this.navigateBack();
        }
      }
    );
  }

  setDeviceDetailsForm() {
    this.deviceForm = this.formBuilder.group({
      search: new FormControl(''),
      filter: new FormControl(''),
    });
    this.uid = sessionStorage.getItem('uid') || '';
    this.imei = sessionStorage.getItem('imei') || '';
    this.deviceForm?.get('search')?.setValue(this.imei ? this.imei : '');
    this.size = 10;
    this.totalCount = 0;
    this.page = 1;
    this.size2 = 10;
    this.totalCount2 = 0;
    this.page2 = 1;
    this.deviceHealth = [];
    this.deviceLogin = [];
    this.size3 = 10;
    this.page3 = 1;
    this.filter = '';
    this.totalLength = 0;
  }

  deviceDashboard() {
    this._showSpinner();
    this.apiMicroservice.deviceDashboard(this.imei).subscribe({
      next: (res) => {
        if (res.data.deviceDetails.length > 0) {
          this.deviceDetails = res.data.deviceDetails[0];
          this.deviceLogin = res.data.loginPacket;
          this.totalCount = this.deviceLogin.length;
          this.deviceHealth = res.data.healthPacket;
          this.totalCount2 = this.deviceHealth.length;
          this.simDataDetails = res.data.simDataDetails;
          sessionStorage.setItem('uid', this.deviceDetails.uid?.trim() || '');
          sessionStorage.setItem('imei', this.deviceDetails.imei?.trim() || '');
          this.uid = sessionStorage.getItem('uid') || '';
          this.imei = sessionStorage.getItem('imei') || '';
          this._hideSpinner();
          this.apiMicroservice.openSnackbar('Data Fetched Successfully.');
        } else {
          this._hideSpinner();
          this.apiMicroservice.openSnackbar('No Data Found');
        }
      },
      error: (ERROR: HttpErrorResponse) => {
        this._hideSpinner();
        this.apiMicroservice.openSnackbar(
          ERROR.error.message || 'No Data Found'
        );
      },
    });
  }

  parseInt(mainInputVtg: string): number {
    return parseInt(mainInputVtg, 10);
  }

  viewLoginPacketDetails(data: {
    REQID_LOGIN_MSG_TATA?: string;
    RTCL_VERSION_TATA?: string;
    Time?: string;
    IMEI?: string;
    ICCID?: string;
    chesisNo?: string;
    firmwareSource?: string;
    primaryIp?: string;
    secondaryIp?: string;
    secondaryPort?: string;
    noOfFuelTank?: string;
    primaryTankCap?: string;
    primaryTankWidth?: string;
    primaryTankHeight?: string;
    primaryTankDiameter?: string;
    primaryTankType?: string;
    primaryTankAFTType?: string;
    secondaryTankCap?: string;
    secondaryTankLen?: string;
    secondaryTankWidth?: string;
    secondaryTankHeight?: string;
    secondaryTankDiameter?: string;
    secondaryTankType?: string;
    latitude?: string;
    latitudeDir?: string;
    longitude?: string;
    longitudeDir?: string;
    mainInputVtg?: string;
    intBatteryVtg?: string;
    ignition?: string;
    tamper?: string;
    emergency?: string;
    calibValidFlag?: string;
    gpsDataFlag?: string;
  }) {
    this.selectedLoginPacket = data;
    document
      ?.getElementById('loginPacketDetails')
      ?.parentElement?.classList.add('active');
  }

  viewHealthPacketDetails(data: {
    packetType?: string;
    Reserved?: string;
    UIN?: string;
    fwVer?: string;
    upTime?: string;
    CALIB?: string;
    angleStatic?: string;
    rawAxisStaticX_AXIS?: string;
    rawAxisStaticY_AXIS?: string;
    rawAxisStaticZ_AXIS?: string;
    angleMotion?: string;
    rawAxisMotionX_AXIS?: string;
    rawAxisMotionY_AXIS?: string;
    rawAxisMotionZ_AXIS?: string;
    usedHeap?: string;
    totalHeap?: string;
    histCount?: string;
    epoch?: string;
    IGN?: string;
    wirecut?: string;
    emergency?: string;
    ntBatt?: string;
    extBatt?: string;
    analogV1?: string;
    analogV2?: string;
    boxTamperRaw?: string;
    gPSDate?: string;
    gPSTime?: string;
    gPSFixQUA?: string;
    lat?: string;
    latDir?: string;
    long?: string;
    longDir?: string;
    numSat?: string;
    speed?: string;
    lastSynced?: string;
    nwState?: string;
    CSQ?: string;
    CREG?: string;
    CGREG?: string;
    SOCKETSTATE?: string;
    mqtt?: string;
    oprName?: string;
    switchRetryCount?: string;
    rebootCounter?: string;
    canBusStatus?: string;
    gpsFwVersion?: string;
    gsmFwVersion?: string;
    footer?: string;
  }) {
    this.selectedHealthPacket = data;
    document
      ?.getElementById('healthPacketDetails')
      ?.parentElement?.classList.add('active');
  }

  downloadLoginPacketData() {
    if (confirm('Are you sure?')) {
      this._showSpinner();
      const exportData = this.deviceLogin.map((item) =>
        omit(item, ['_id', 'updatedAt', '__v'])
      );
      exportAsCsvFile(exportData, 'Login_Packets');
      this._hideSpinner();
      this.apiMicroservice.openSnackbar('File Ready For Download.');
    }
  }

  downloadHealthPacketReport() {
    if (confirm('Are you sure?')) {
      this._showSpinner();
      const exportData = this.deviceHealth.map((item) =>
        omit(item, ['_id', 'updatedAt', '__v'])
      );
      exportAsCsvFile(exportData, 'Health_Packets');
      this._hideSpinner();
      this.apiMicroservice.openSnackbar('File Ready For Download.');
    }
  }

  onPageChange2(event: number) {
    this.page2 = event;
  }

  onSizeChange2(event: number) {
    this.page2 = 1;
    this.size2 = event;
  }

  onPageChange(event: number) {
    this.page = event;
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
  }

  onSearch(event: string) {
    if (event.length !== 15 || isNaN(parseInt(event))) {
      this.apiMicroservice.openSnackbar('Invalid IMEI. Please try again.');
    } else {
      this._showSpinner();
      sessionStorage.setItem('imei', event);
      this.ngOnInit();
    }
  }

  getDeviceSystemActivityLog() {
    this._showSpinner();
    this.apiMicroservice
      .getDeviceSystemActivityLog(
        this.page3,
        this.size3,
        this.imei,
        this.filter
      )
      .subscribe((res) => {
        if (res.status) {
          this._hideSpinner();
          this.Responses = res.data.data;
          this.totalLength = res.data.totalItems;
          this.apiMicroservice.openSnackbar('Fetched Successfully');
        } else {
          this._hideSpinner();
          this.apiMicroservice.openSnackbar('Something went wrong');
        }
      });
  }

  onPageChange3(event: number) {
    this.page3 = event;
    this.getDeviceSystemActivityLog();
  }

  onSizeChange3(event: number) {
    this.page3 = 1;
    this.size3 = event;
    this.getDeviceSystemActivityLog();
  }

  onFilter(event: string) {
    this.page3 = 1;
    this.filter = event;
    this.deviceForm.get('filter')?.setValue(this.filter ? this.filter : '');
    this.getDeviceSystemActivityLog();
  }

  // DownloadOutputReport() {
  //   try {
  //     this._showSpinner();
  //     this.apiMicroservice
  //       .getDeviceSystemActivityLog(1, this.totalLength, this.imei, this.filter)
  //       .subscribe((res) => {
  //         if (res.status) {
  //           const exportData = res.data.data.flatMap((el, index) =>
  //             el.activities.map((el1) => ({
  //               'Row Number': index + 1, // add row number (starting from 1)
  //               IMEI: el.imei || '--',
  //               'Activity Type': el1.activityType || '--',
  //               'Activity Performed': el1.serverResponse || '--',
  //               Packet: el.loginPacket,
  //               'Activity Performed At': el.createdAt,
  //             }))
  //           );
  //           exportAsExcelFile(exportData, 'Device_System_Activity_Log_Report');
  //           this.apiMicroservice.openSnackbar('File Ready.');
  //           this._hideSpinner();
  //         } else {
  //           this._hideSpinner();
  //           this.apiMicroservice.openSnackbar('Something went wrong');
  //         }
  //       });
  //   } catch (error) {
  //     this._hideSpinner();
  //     console.error(error);
  //   }
  // }

  DownloadOutputReport() {
    this._showSpinner();
    this.apiMicroservice
      .downloadDeviceSystemActivityLog(this.imei, this.filter)
      .subscribe({
        next: (res) => {
          this._hideSpinner();
          if (res.status && res.fileDownloadUrl) {
            window.open(res.fileDownloadUrl, '_blank');
            this.apiMicroservice.openSnackbar('File Ready for Download.');
          } else {
            this.apiMicroservice.openSnackbar('No data found.');
          }
        },
        error: (err) => {
          this._hideSpinner();
          console.error(err);
          this.apiMicroservice.openSnackbar('Something went wrong.');
        },
      });
  }

  closeModal() {
    document
      ?.getElementById('loginPacketDetails')
      ?.parentElement?.classList.remove('active');
    document
      ?.getElementById('healthPacketDetails')
      ?.parentElement?.classList.remove('active');
  }

  redirectToOTA(): void {
    if (this.deviceDetails && this.deviceDetails.imei) {
      // Serialize the route and build the full URL
      sessionStorage.setItem('otaDeviceHistoryImei', this.imei);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/manual-ota'])
      );
      const fullUrl = window.location.origin + url;

      // Open the route in a new tab
      window.open(fullUrl, '_blank');
    } else {
      this.apiMicroservice.openSnackbar(
        'Device details not available, redirection is disabled.'
      );
    }
  }

  redirectToFOTA(): void {
    if (this.deviceDetails && this.deviceDetails.imei) {
      sessionStorage.setItem('fotaDeviceHistoryImei', this.imei);
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/manual-fota'])
      );
      const fullUrl = window.location.origin + url;

      // Open the route in a new tab
      window.open(fullUrl, '_blank');
    } else {
      this.apiMicroservice.openSnackbar(
        'Device details not available, redirection is disabled.'
      );
    }
  }

  getLocation(lat: string, long: string) {
    // Convert to numbers
    const latitude = parseFloat(lat);
    const longitude = parseFloat(long);

    // Validate latitude and longitude
    if (
      isNaN(latitude) ||
      isNaN(longitude) ||
      latitude < -90 ||
      latitude > 90 ||
      longitude < -180 ||
      longitude > 180
    ) {
      this.apiMicroservice.openSnackbar(
        'Invalid coordinates. Unable to open location.'
      );
      return;
    }

    const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  generateGoogleMapsLink() {
    const baseUrl = 'https://www.google.com/maps/dir/';

    // Filter out invalid coordinates (like 0,0)
    const validCoordinates = this.deviceLogin
      .filter((item: { latitude?: string; longitude?: string }) => {
        const isValid =
          item.latitude !== '0.000000' && item.longitude !== '0.000000';
        return isValid;
      })
      .map((item: { latitude?: string; longitude?: string }) => {
        const coords = [item.latitude, item.longitude];
        return coords;
      });

    // Limit waypoints to 25 (Google Maps limit)
    const limitedCoordinates = validCoordinates.slice(0, 25);

    if (limitedCoordinates.length < 2) {
      this.apiMicroservice.openSnackbar(
        'At least two valid coordinates are required.'
      );
      return;
    }

    // Format the coordinates correctly
    const points = limitedCoordinates.map((coord) => coord.join(',')).join('/');

    return `${baseUrl}${points}`;
  }

  trackLocation() {
    this.apiMicroservice.openSnackbar('Tracking upto last 25 locations');
    const url = this.generateGoogleMapsLink();
    if (url) {
      window.open(url, '_blank');
    }
  }

  navigateBack() {
    this.apiMicroservice.back();
  }

  // deviceDashboard() and getDeviceSystemActivityLog() run concurrently from
  // ngOnInit(); each independently showing/hiding the spinner (a simple
  // boolean toggle, not reference-counted) meant whichever finished first
  // hid it while the other was still loading. This counter only calls
  // through to the real show/hide on the 0->1 and 1->0 transitions, so the
  // spinner stays up until every in-flight request has completed.
  private _showSpinner() {
    if (this.spinnerCount++ === 0) this.spinner.show();
  }

  private _hideSpinner() {
    if (--this.spinnerCount === 0) this.spinner.hide();
  }
}
